import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as moment from 'moment';

import { AuthService } from '../services/auth.service';
import { CheckAmbulanciaService } from '../services/check-ambulancia.service';

@Component({
  selector: 'app-checklist-ver',
  templateUrl: './checklist-ver.component.html',
  styleUrls: ['./checklist-ver.component.css'],
	animations: [loadingFade]
})
export class ChecklistVerComponent implements OnInit {

  public loading;
  public submitting = false;

	public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];

  public check_ambulancia_id = null;
  public justificativa = null;

    //filtros
    public cliente_id___cliente = null;
    public unidade_id___unidade = null;
    public veiculo_id___veiculo = null;
    public check_ambulancia_turno___periodo = null;
    public check_ambulancia_data___data_i = null;
    public check_ambulancia_data___data_f=  null;
    public especialidade_veiculo_id___veiculo = null;
    public profissional_id___profissional = null;


  constructor(
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private location: Location,
              private router: Router,
              private checkAmbulanciaSvc: CheckAmbulanciaService
              ) { }

  ngOnInit() {
    this.criaForm();
    this.loading = true;

		this.route.params.subscribe( params => {

      console.log("params = " , params);

			if (params.id) {

        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "check_ambulancia_turno___periodo": { 
                this.check_ambulancia_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "check_ambulancia_data___data_i": { 
                this.check_ambulancia_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "check_ambulancia_data___data_f": { 
                this.check_ambulancia_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "especialidade_veiculo_id___veiculo": { 
                this.especialidade_veiculo_id___veiculo = loSplitValor[1];
                 break; 
              }    
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }


        }        
        
				this.check_ambulancia_id = params.id;
				this.checkAmbulanciaSvc.getCheckAmbulancia(params.id).then((data: any) => {
          if(data.check_ambulancia_justificativa != null){
            this.justificativa = true;
          }
					this.preencheForm({
            check_ambulancia_id:  data.check_ambulancia_id,
            check_ambulancia_data:  moment(data.check_ambulancia_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            check_ambulancia_turno:  data.check_ambulancia_turno,
            check_ambulancia_justificativa:  data.check_ambulancia_justificativa,
            check_ambulancia_quilometragem:  this.mascaraKm(data.check_ambulancia_quilometragem),
            check_ambulancia_combustivel:  data.check_ambulancia_combustivel,
            check_ambulancia_oleo_motor: data.check_ambulancia_oleo_motor,
            check_ambulancia_oleo_motor_obs: data.check_ambulancia_oleo_motor_obs,
            check_ambulancia_agua_radiador: data.check_ambulancia_agua_radiador,
            check_ambulancia_agua_radiador_obs: data.check_ambulancia_agua_radiador_obs,
            check_ambulancia_fluido_freio: data.check_ambulancia_fluido_freio,
            check_ambulancia_fluido_freio_obs: data.check_ambulancia_fluido_freio_obs,
            check_ambulancia_injetor_agua: data.check_ambulancia_injetor_agua,
            check_ambulancia_injetor_agua_obs: data.check_ambulancia_injetor_agua_obs,
            check_ambulancia_freio_de_mao: data.check_ambulancia_freio_de_mao,
            check_ambulancia_freio_de_mao_obs: data.check_ambulancia_freio_de_mao_obs,
            check_ambulancia_partida: data.check_ambulancia_partida,
            check_ambulancia_partida_obs: data.check_ambulancia_partida_obs,
            check_ambulancia_luz_re: data.check_ambulancia_luz_re,
            check_ambulancia_luz_re_obs: data.check_ambulancia_luz_re_obs,
            check_ambulancia_luz_freio: data.check_ambulancia_luz_freio,
            check_ambulancia_luz_freio_obs: data.check_ambulancia_luz_freio_obs,
            check_ambulancia_sirene: data.check_ambulancia_sirene,
            check_ambulancia_sirene_obs: data.check_ambulancia_sirene_obs,
            check_ambulancia_buzina: data.check_ambulancia_buzina,
            check_ambulancia_buzina_obs: data.check_ambulancia_buzina_obs,
            check_ambulancia_ac: data.check_ambulancia_ac,
            check_ambulancia_ac_obs: data.check_ambulancia_ac_obs,
            check_ambulancia_ilu_salao: data.check_ambulancia_ilu_salao,
            check_ambulancia_ilu_salao_obs: data.check_ambulancia_ilu_salao_obs,
            check_ambulancia_tomadas: data.check_ambulancia_tomadas,
            check_ambulancia_tomadas_obs: data.check_ambulancia_tomadas_obs,
            check_ambulancia_cinto: data.check_ambulancia_cinto,
            check_ambulancia_cinto_obs: data.check_ambulancia_cinto_obs,
            check_ambulancia_cones: data.check_ambulancia_cones,
            check_ambulancia_cones_obs: data.check_ambulancia_cones_obs,
            check_ambulancia_extintor: data.check_ambulancia_extintor,
            check_ambulancia_extintor_obs: data.check_ambulancia_extintor_obs,
            check_ambulancia_macaco: data.check_ambulancia_macaco,
            check_ambulancia_macaco_obs: data.check_ambulancia_macaco_obs,
            check_ambulancia_chave_roda: data.check_ambulancia_chave_roda,
            check_ambulancia_chave_roda_obs: data.check_ambulancia_chave_roda_obs,
            check_ambulancia_triangulo: data.check_ambulancia_triangulo,
            check_ambulancia_triangulo_obs: data.check_ambulancia_triangulo_obs,
            check_ambulancia_radio: data.check_ambulancia_radio,
            check_ambulancia_radio_obs: data.check_ambulancia_radio_obs,
            check_ambulancia_gps: data.check_ambulancia_gps,
            check_ambulancia_gps_obs: data.check_ambulancia_gps_obs,
            check_ambulancia_celular: data.check_ambulancia_celular,
            check_ambulancia_celular_obs: data.check_ambulancia_celular_obs,
            check_ambulancia_carregador: data.check_ambulancia_carregador,
            check_ambulancia_carregador_obs: data.check_ambulancia_carregador_obs,
            check_ambulancia_antena: data.check_ambulancia_antena,
            check_ambulancia_antena_obs: data.check_ambulancia_antena_obs,
            check_ambulancia_pneus: data.check_ambulancia_pneus,
            check_ambulancia_pneus_obs: data.check_ambulancia_pneus_obs,
            check_ambulancia_estepe: data.check_ambulancia_estepe,
            check_ambulancia_estepe_obs: data.check_ambulancia_estepe_obs,
            check_ambulancia_portas: data.check_ambulancia_portas,
            check_ambulancia_portas_obs: data.check_ambulancia_portas_obs,
            check_ambulancia_vidros: data.check_ambulancia_vidros,
            check_ambulancia_vidros_obs: data.check_ambulancia_vidros_obs,
            check_ambulancia_lavada: data.check_ambulancia_lavada,
            check_ambulancia_lavada_obs: data.check_ambulancia_lavada_obs,
            mesorregiao: data.cliente.cliente_nome,
            unidade: data.unidade.unidade_nome,
            profissional: data.profissional.profissional_nome,
            veiculo: data.veiculo.veiculo_placa + ' - ' + data.veiculo.veiculo_numero,
            check_ambulancia_giroflex: data.check_ambulancia_giroflex,
            check_ambulancia_giroflex_obs: data.check_ambulancia_giroflex_obs,
            check_ambulancia_estrobo: data.check_ambulancia_estrobo,
            check_ambulancia_estrobo_obs: data.check_ambulancia_estrobo_obs,
            check_ambulancia_retrovisores: data.check_ambulancia_retrovisores,
            check_ambulancia_farois: data.check_ambulancia_farois,
            check_ambulancia_piscas: data.check_ambulancia_piscas,
            check_ambulancia_lanterna_tras: data.check_ambulancia_lanterna_tras,
            check_ambulancia_retrovisores_obs: data.check_ambulancia_retrovisores_obs,
            check_ambulancia_farois_obs: data.check_ambulancia_farois_obs,
            check_ambulancia_piscas_obs: data.check_ambulancia_piscas_obs,
            check_ambulancia_lanterna_tras_obs: data.check_ambulancia_lanterna_tras_obs,
            check_ambulancia_palheta:data.check_ambulancia_palheta,
            check_ambulancia_palheta_obs:data.check_ambulancia_palheta_obs,
            check_ambulancia_luz_placa:data.check_ambulancia_luz_placa,
            check_ambulancia_luz_placa_obs:data.check_ambulancia_luz_placa_obs,
            check_ambulancia_cilindro_o2:data.check_ambulancia_cilindro_o2,
            check_ambulancia_cilindro_o2_obs:data.check_ambulancia_cilindro_o2_obs,
            check_ambulancia_chave_o2:data.check_ambulancia_chave_o2,
            check_ambulancia_chave_o2_obs:data.check_ambulancia_chave_o2_obs,
            check_ambulancia_maca_rigida:data.check_ambulancia_maca_rigida,
            check_ambulancia_maca_rigida_obs:data.check_ambulancia_maca_rigida_obs,
            check_ambulancia_maca_retratil:data.check_ambulancia_maca_retratil,
            check_ambulancia_maca_retratil_obs:data.check_ambulancia_maca_retratil_obs,
            check_ambulancia_cartao_abast:data.check_ambulancia_cartao_abast,
            check_ambulancia_cartao_abast_obs:data.check_ambulancia_cartao_abast_obs,
            check_ambulancia_obs:data.check_ambulancia_obs,
            check_ambulancia_intercorrencia:data.check_ambulancia_intercorrencia
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
  }

  criaForm(){
    this.formChecklist = this.fb.group({
			check_ambulancia_id: {value:null, disabled:true},
      check_ambulancia_data: {value:null, disabled:true},
      check_ambulancia_turno: {value:null, disabled:true},
      check_ambulancia_justificativa: {value:null, disabled:true},
      check_ambulancia_quilometragem: {value:null, disabled:true},
      check_ambulancia_combustivel: {value:null, disabled:true},
      check_ambulancia_oleo_motor:{value:null, disabled:true},
      check_ambulancia_oleo_motor_obs:{value:null, disabled:true},
      check_ambulancia_agua_radiador:{value:null, disabled:true},
      check_ambulancia_agua_radiador_obs:{value:null, disabled:true},
      check_ambulancia_fluido_freio:{value:null, disabled:true},
      check_ambulancia_fluido_freio_obs:{value:null, disabled:true},
      check_ambulancia_injetor_agua:{value:null, disabled:true},
      check_ambulancia_injetor_agua_obs:{value:null, disabled:true},
      check_ambulancia_freio_de_mao:{value:null, disabled:true},
      check_ambulancia_freio_de_mao_obs:{value:null, disabled:true},
      check_ambulancia_partida:{value:null, disabled:true},
      check_ambulancia_partida_obs:{value:null, disabled:true},
      check_ambulancia_luz_re:{value:null, disabled:true},
      check_ambulancia_luz_re_obs:{value:null, disabled:true},
      check_ambulancia_luz_freio:{value:null, disabled:true},
      check_ambulancia_luz_freio_obs:{value:null, disabled:true},
      check_ambulancia_sirene:{value:null, disabled:true},
      check_ambulancia_sirene_obs:{value:null, disabled:true},
      check_ambulancia_buzina:{value:null, disabled:true},
      check_ambulancia_buzina_obs:{value:null, disabled:true},
      check_ambulancia_ac:{value:null, disabled:true},
      check_ambulancia_ac_obs:{value:null, disabled:true},
      check_ambulancia_ilu_salao:{value:null, disabled:true},
      check_ambulancia_ilu_salao_obs:{value:null, disabled:true},
      check_ambulancia_tomadas:{value:null, disabled:true},
      check_ambulancia_tomadas_obs:{value:null, disabled:true},
      check_ambulancia_cinto:{value:null, disabled:true},
      check_ambulancia_cinto_obs:{value:null, disabled:true},
      check_ambulancia_cones:{value:null, disabled:true},
      check_ambulancia_cones_obs:{value:null, disabled:true},
      check_ambulancia_extintor:{value:null, disabled:true},
      check_ambulancia_extintor_obs:{value:null, disabled:true},
      check_ambulancia_macaco:{value:null, disabled:true},
      check_ambulancia_macaco_obs:{value:null, disabled:true},
      check_ambulancia_chave_roda:{value:null, disabled:true},
      check_ambulancia_chave_roda_obs:{value:null, disabled:true},
      check_ambulancia_triangulo:{value:null, disabled:true},
      check_ambulancia_triangulo_obs:{value:null, disabled:true},
      check_ambulancia_radio:{value:null, disabled:true},
      check_ambulancia_radio_obs:{value:null, disabled:true},
      check_ambulancia_gps:{value:null, disabled:true},
      check_ambulancia_gps_obs:{value:null, disabled:true},
      check_ambulancia_celular:{value:null, disabled:true},
      check_ambulancia_celular_obs:{value:null, disabled:true},
      check_ambulancia_carregador:{value:null, disabled:true},
      check_ambulancia_carregador_obs:{value:null, disabled:true},
      check_ambulancia_antena:{value:null, disabled:true},
      check_ambulancia_antena_obs:{value:null, disabled:true},
      check_ambulancia_pneus:{value:null, disabled:true},
      check_ambulancia_pneus_obs:{value:null, disabled:true},
      check_ambulancia_estepe:{value:null, disabled:true},
      check_ambulancia_estepe_obs:{value:null, disabled:true},
      check_ambulancia_portas:{value:null, disabled:true},
      check_ambulancia_portas_obs:{value:null, disabled:true},
      check_ambulancia_vidros:{value:null, disabled:true},
      check_ambulancia_vidros_obs:{value:null, disabled:true},
      check_ambulancia_lavada:{value:null, disabled:true},
      check_ambulancia_lavada_obs:{value:null, disabled:true},
      check_ambulancia_giroflex: {value:null, disabled:true},
      check_ambulancia_giroflex_obs: {value:null, disabled:true},
      check_ambulancia_estrobo: {value:null, disabled:true},
      check_ambulancia_estrobo_obs: {value:null, disabled:true},
      mesorregiao: {value:null, disabled:true},
      unidade: {value:null, disabled:true},
      profissional: {value:null, disabled:true},
      veiculo: {value:null, disabled:true},      
      check_ambulancia_retrovisores: {value:null, disabled:true},
      check_ambulancia_retrovisores_obs: {value:null, disabled:true},
      check_ambulancia_farois: {value:null, disabled:true},
      check_ambulancia_farois_obs: {value:null, disabled:true},
      check_ambulancia_piscas: {value:null, disabled:true},
      check_ambulancia_piscas_obs: {value:null, disabled:true},
      check_ambulancia_lanterna_tras: {value:null, disabled:true},
      check_ambulancia_lanterna_tras_obs: {value:null, disabled:true},
      check_ambulancia_palheta: {value:null, disabled:true},
      check_ambulancia_palheta_obs: {value:null, disabled:true},
      check_ambulancia_luz_placa: {value:null, disabled:true},
      check_ambulancia_luz_placa_obs: {value:null, disabled:true},
      check_ambulancia_cilindro_o2: {value:null, disabled:true},
      check_ambulancia_cilindro_o2_obs: {value:null, disabled:true},
      check_ambulancia_chave_o2: {value:null, disabled:true},
      check_ambulancia_chave_o2_obs: {value:null, disabled:true},
      check_ambulancia_maca_rigida: {value:null, disabled:true},
      check_ambulancia_maca_rigida_obs: {value:null, disabled:true},
      check_ambulancia_maca_retratil: {value:null, disabled:true},
      check_ambulancia_maca_retratil_obs: {value:null, disabled:true},
      check_ambulancia_cartao_abast: {value:null, disabled:true},
      check_ambulancia_cartao_abast_obs: {value:null, disabled:true},
      check_ambulancia_obs: {value:null, disabled:true},
      check_ambulancia_intercorrencia: {value:null, disabled:true}
    });
  }

  preencheForm(dados) {
		this.formChecklist.setValue(dados);
  }
 
  print(id){
    //let url = location.href.split('#')[0] + '#' +'(print:print/checkambulancia/'+ id +')'
    //window.open(url);
    this.router.navigate(['home/checkambulanciaprint/' + id]);
	}

  onClickVoltar(){

    let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
    params += "&unidade_id___unidade=" + this.unidade_id___unidade;
    params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
    params += "&check_ambulancia_turno___periodo=" + this.check_ambulancia_turno___periodo;
    params += "&check_ambulancia_data___data_i=" + this.check_ambulancia_data___data_i;
    params += "&check_ambulancia_data___data_f=" + this.check_ambulancia_data___data_f;
    params += "&especialidade_veiculo_id___veiculo=" + this.especialidade_veiculo_id___veiculo;
    params += "&profissional_id___profissional=" + this.profissional_id___profissional;

    console.log("[onClickVoltar]", params);

    this.router.navigate(['/home/checklistfiltro/' + params]);

  }

  mascaraKm(valor){

		if(valor != "" && valor != null){

			if(valor.length <= 3){
				return valor;
			}else{

				if(valor.indexOf(".") != -1){

					var sValor = valor.split(".");
					if(sValor[1] == "000"){
						return sValor[0];
					}else{
						return sValor[0] + sValor[1];
					}

				}

			}


		}else{
      return "";
    }

	  }
  
}
